<div>
  <router-outlet></router-outlet>
</div>

<app-loading></app-loading>

<app-message-popup></app-message-popup>
